<template>
  <div>
    <div :style="`border-radius: 4px;background-color: ${accentColor};padding:5px;width:30px;height:30px;`">
      <v-img
          src="../assets/handle.png"
          style="margin-top: 5px"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "DragHandle",
  data() {
    return {
      accentColor: null,
    }
  },
  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary
  },
}
</script>

<style scoped>

</style>